import React, { useEffect } from 'react';
import ModalComponent from '../modal/ModalComponent';
import { Auth } from 'aws-amplify';
import useToken from 'api/token';

export default function SessionExpiredModal() {
    const token = useToken();

    const signOut = async () => {
        try {
            await Auth.signOut();
        } catch (error) {
            console.log('error signing out: ', error);
        }
    };

    useEffect(() => {
        if (token === 'expired') {
            console.log('Session expired. Please sign in again.');
        }
    }, [token]);

    return (
        <ModalComponent
            open={token === 'expired'}
            header="Session expired"
            body="Your session expired. Try to sign in."
            actions={[
                {
                    variant: 'outlined',
                    label: 'Sign In',
                    onClick: signOut,
                },
            ]}
            onClose={() => {}}
        />
    );
}
